import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewImportaPadron = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'importa_padron',
        name: 'Importa Padron',
        component: ViewImportaPadron,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
